import { DedicatedPackageOutput } from '@allocab/allocab-dedicated-driver-types';
import { PackageStatus } from '@allocab/allocab-dedicated-driver-types/lib/src/dedicated-package/types';

import { assertNever } from './common';
import { IndicatorVariant } from '../components/BadgeIndicator';
import { t } from '../services/translation/translation';

export const getTripPackageStatus = (tripPackage: DedicatedPackageOutput) => {
  switch (tripPackage.status) {
    case 'DRAFT':
      return t('driver-package.status.draft');
    case 'PROPOSED':
      return t('driver-package.status.proposed');
    case 'ACCEPTED':
      return t('driver-package.status.accepted');
    case 'IN_PROGRESS':
      return t('driver-package.status.inprogress');
    case 'CANCELLED':
      return t('driver-package.status.cancelled');
    case 'TERMINATED':
      return t('driver-package.status.terminated');
    default:
      assertNever(tripPackage.status, '[getTripPackageStatus] Status unknown');
      return '';
  }
};

export const getTripPackageStatusVariant = (tripPackage: DedicatedPackageOutput): IndicatorVariant => {
  switch (tripPackage.status) {
    case 'DRAFT':
      return 'gray';
    case 'PROPOSED':
      return 'blue';
    case 'ACCEPTED':
      return 'green';
    case 'IN_PROGRESS':
      return 'yellow';
    case 'CANCELLED':
      return 'red';
    case 'TERMINATED':
      return 'gray';
    default:
      assertNever(tripPackage.status, '[getTripPackageStatusVariant] Status unknown');
      return 'gray';
  }
};

export const getTripPackageNameStatus = (status: PackageStatus) => {
  switch (status) {
    case 'DRAFT':
      return t('driver-package.status.draft');
    case 'PROPOSED':
      return t('driver-package.status.proposed');
    case 'ACCEPTED':
      return t('driver-package.status.accepted');
    case 'IN_PROGRESS':
      return t('driver-package.status.inprogress');
    case 'CANCELLED':
      return t('driver-package.status.cancelled');
    case 'TERMINATED':
      return t('driver-package.status.terminated');
    default:
      assertNever(status, '[getTripPackageStatus] Status unknown');
      return '';
  }
};
